import {render} from 'preact';

import App from '@/sandbox/App';

render(<App />, document.getElementById('preact-root')!);
